import React from "react";

/**
 * High-quality CSS phone fallback — displays a real FemCare UI screenshot
 * inside a realistic device frame. Used when WebGL is unavailable or on very small screens.
 */
export default function PhoneCSSFallback({ screenSrc }) {
    return (
        <div className="relative flex items-center justify-center w-full h-full" data-testid="hero-phone-fallback">
            <div
                aria-hidden
                className="absolute -inset-16 rounded-full blur-3xl opacity-60"
                style={{ background: "radial-gradient(circle,#ffd1e3 0%,#d4a0c0 45%,transparent 75%)" }}
            />
            <div
                className="relative w-[280px] sm:w-[300px] lg:w-[320px] aspect-[9/19] rounded-[2.4rem] p-[6px]"
                style={{
                    background: "linear-gradient(155deg,#1a1a2e 0%,#3a3a52 50%,#1a1a2e 100%)",
                    boxShadow: "0 40px 90px -25px rgba(31,33,55,0.55), 0 0 0 1.5px rgba(255,255,255,0.14) inset",
                    transform: "rotateY(-6deg) rotateX(4deg)",
                    transformStyle: "preserve-3d",
                }}
            >
                <div className="relative w-full h-full rounded-[2rem] overflow-hidden bg-white">
                    <div className="absolute top-1.5 left-1/2 -translate-x-1/2 w-24 h-5 bg-black rounded-full z-20" />
                    {screenSrc && (
                        <img
                            src={screenSrc}
                            alt="Femcare app screen showing cycle tracking and period predictions"
                            className="absolute inset-0 w-full h-full object-cover"
                            loading="eager"
                        />
                    )}
                    <div className="absolute inset-0 pointer-events-none rounded-[2rem]"
                         style={{ background: "linear-gradient(120deg,rgba(255,255,255,0.22) 0%,transparent 35%,transparent 65%,rgba(255,255,255,0.10) 100%)" }} />
                </div>
            </div>
        </div>
    );
}
